import { toast } from "@/components/ui/use-toast";

const LINES = {
  added: "Card added to your collection. 👍 Way to go!",
  saved: "Saved successfully. ✅",
  hearted: "Hearted hard. ♥",
  followed: "Followed! 🫶",
  unfollowed: "Unfollowed.",
  offerSent: "Offer sent! ✉️",
  error: "Something went wrong.",
} as const;

export type CheekyKey = keyof typeof LINES;

export function toastCheeky(key: CheekyKey, extra?: string) {
  toast({
    description: extra ? `${LINES[key]} ${extra}` : LINES[key],
  });
}

